import { render } from "./AddNewRestaurant.vue?vue&type=template&id=51f67af5&scoped=true"
import script from "./AddNewRestaurant.vue?vue&type=script&lang=js"
export * from "./AddNewRestaurant.vue?vue&type=script&lang=js"

import "./AddNewRestaurant.vue?vue&type=style&index=0&id=51f67af5&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f67af5"]])

export default __exports__